/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSizeProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconSize from './useIconSize';

/*
 * Defines the Design Language System (DLS) Notification Calendar Icon component.
 */
export const NotificationCalendarIcon = ({size}: IconSizeProps) => {
  const iconSize = useIconSize(size);
  return (
    <ThemeIconProvider name='NotificationCalendarIcon' size={size} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d='M21.4999 4.21826H2.5C2.22386 4.21826 2 4.44212 2 4.71826V21.7183C2 21.9944 2.22386 22.2183 2.5 22.2183H21.4999C21.776 22.2183 21.9999 21.9944 21.9999 21.7183V4.71826C21.9999 4.44212 21.776 4.21826 21.4999 4.21826Z'
          stroke={dlsColor('grey3')}
          strokeWidth={1.5}
          strokeMiterlimit={10} />
        <path d='M2.12939 10.7173H22.0001'
          stroke={dlsColor('grey3')}
          strokeWidth={1.5}
          strokeMiterlimit={10} />
        <path d='M6.66187 2V6.39068'
          stroke={dlsColor('grey3')}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          strokeLinecap='round' />
        <path d='M17.0139 2V6.39068'
          stroke={dlsColor('grey3')}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          strokeLinecap='round' />
      </svg>
    )} />
  );
};
